import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      title: 'Order Book',
      description: 'View real-time order flow',
      icon: 'BookOpen',
      variant: 'default',
      path: '/real-time-order-book'
    },
    {
      title: 'Strategy Builder',
      description: 'Create trading strategies',
      icon: 'Settings',
      variant: 'outline',
      path: '/strategy-builder'
    },
    {
      title: 'Market Analysis',
      description: 'Deep market insights',
      icon: 'TrendingUp',
      variant: 'outline',
      path: '/market-analysis'
    },
    {
      title: 'Compliance',
      description: 'Check regulatory status',
      icon: 'Shield',
      variant: 'secondary',
      path: '/compliance-dashboard'
    }
  ];

  const handleActionClick = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {actions?.map((action) => (
          <Button
            key={action?.title}
            variant={action?.variant}
            onClick={() => handleActionClick(action?.path)}
            iconName={action?.icon}
            iconPosition="left"
            className="h-auto p-4 flex-col items-start text-left"
          >
            <div className="flex items-center gap-2 w-full mb-1">
              <span className="font-medium">{action?.title}</span>
            </div>
            <span className="text-xs text-muted-foreground">
              {action?.description}
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;